  <div class=" text-center" *ngIf ="is_vw_creative">
    <div class="d-flex justify-content-between">
      <div >
        <img src="assets/images/mlogo-01.jpg" class="img-responsive" style="width:auto; height:60px; padding:10px 0 0 0;" alt="Orix"  />
      </div>
    
      <!-- <div>
        <img src="assets/images/1500-orix-logo.jpg" class="img-responsive"  style="width:auto;height:60px;" />
      </div> -->
    </div>
    <h2 style="padding-top: 10px;">Maruti Suzuki Subscribe Enquiry Form</h2>
  </div>
